// async function fetchWorkedDaysAsync(worker_id, year) {
//     try {
//         const response = await fetch(`/wp-json/eSantier/v1/worked_days?worker_id=${worker_id}&year=${year}`);
//         if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
//         return await response.json();
//     } catch (error) {
//         console.error('Error loading worked days:', error);
//         throw error; // Re-throw for caller to handle
//     }
// }

// async function updateWorkedDays(worker_id, year) {
//     // Initialize storage
//     if (!ESR.StoreWorkedDates) ESR.StoreWorkedDates = {};
//
//     if (ESR.StoreWorkedDates && ESR.StoreWorkedDates.hasOwnProperty(year)) {
//         return ESR.StoreWorkedDates[year];
//     }
//
//     // Fetch and cache new data
//     try {
//         const workedDays = await fetchWorkedDaysAsync(worker_id, year);
//         ESR.StoreWorkedDates[year] = workedDays;
//         return workedDays;
//     } catch (error) {
//         // If we have cached data, return it even if refresh fails
//         if (ESR.StoreWorkedDates[year]) {
//             console.warn('Using cached data after failed refresh:', error);
//             return ESR.StoreWorkedDates[year];
//         }
//         console.error('No cached data available and fetch failed:', error);
//         throw error; // or return [];
//     }
// }

function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`; // Returns "YYYY-MM-DD"
}


export async function calendarWorker($) {

    const elCalendar = $('#calendar-worker');

    if (!elCalendar.length) return;

    // const endDate = elCalendar.attr('data-date-end-date')?.split('-')
    // const worker_id = elCalendar.attr('data-worker-id');

    //1. Așteaptă încărcarea datelor pentru anul curent
    // await updateWorkedDays(worker_id, endDate[0]);

    // 2. Inițializează calendarul DOAR după ce datele sunt preluate
    elCalendar.datepicker({
        language: 'ro',
        todayBtn: true,
        autoclose: true,
        format: 'yyyy-mm-dd',
        beforeShowDay: function (date) {
            const dateStr = formatDate(date); // Formatează ca 'YYYY-MM-DD'
            const year = date.getFullYear();
            return {
                enabled: true,
                classes: window.userWorkedDays?.includes(dateStr) ? 'worked-day' : ''
            };
        }
    });

    // 3. Ascultă schimbarea anului și reîncarcă datele
    // let currentFetchYear = null;
    // elCalendar.on('changeMonth changeYear', async function (e) {
    //     const year = e.date.getFullYear();
    //
    //     // Only fetch if we haven't loaded this year's data yet
    //     if (year !== currentFetchYear && !ESR.StoreWorkedDates[year]) {
    //         currentFetchYear = year;
    //         await updateWorkedDays(worker_id, year);
    //         elCalendar.datepicker('update');
    //     }
    // });
}